var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.clickItem}},[_c('typo',{class:`link ${_vm.open ? 'open' : ''} level-${_vm.item.level}`,attrs:{"name":"body-12-normal"},domProps:{"innerHTML":_vm._s(_vm.item.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }